import React from 'react';
import CategoryInsights from './CategoryInsights';

const FeaturedInsights = () => {
  return (
    <CategoryInsights
      featured={true}
      titleKey="pages.featuredInsights.title"
      subtitleKey="pages.featuredInsights.subtitle"
      categoryLabelKey="insights.featuredInsights"
    />
  );
};

export default FeaturedInsights;
